module.exports = __webpack_public_path__ + "static/media/bigdot.b20d0833.png";